import Vue from 'vue'
import Router from 'vue-router'
import PrincipalView from './views/PrincipalView'
import ShopView from './views/ShopView'
import AdminView from './views/AdminView'
import { auth } from './services/firebase'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', component: PrincipalView, name: 'home' },
    { path: '/shop', component: ShopView, name: 'shop' },
    { 
      path: '/admin', 
      component: AdminView, 
      name: 'admin',
      meta: { requiresAuth: true }
    }
  ]
})

// Navigation guard para proteger rutas admin
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  
  if (requiresAuth) {
    const unsubscribe = auth.onAuthStateChanged(user => {
      unsubscribe()
      if (user) {
        next()
      } else {
        // Si no está autenticado, la vista de admin mostrará el login
        next()
      }
    })
  } else {
    next()
  }
})

export default router
